import React from "react";
import moment from "moment-with-locales-es6";
moment.locale("fr");

const customHeaderCell = ({ date }) => {
	return <span className="title">{moment(date.toDate()).format("dddd (DD-MM)")}</span>;
};

export default customHeaderCell;
